import React, { useState } from "react";
import { Link } from "react-router-dom";
import SiteLogo from "../../../assets/images/auths/logo.svg";
import Gambling1 from "../../../assets/images/gambling-1.png";
import Gambling2 from "../../../assets/images/gambling-2.png";
import Gambling3 from "../../../assets/images/gambling-3.png";
import Gambling4 from "../../../assets/images/gambling-4.png";
import Gambling5 from "../../../assets/images/game_stopicon.png";
import ContactUsModal from "../../modals/ContactUs/ContactUsModal";
import { ReactComponent as FacebookIcon } from "../../../assets/images/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../../assets/images/instagram.svg";
import { setNavItem } from "../../../utils/localStorage";
import "./Footer.scss";

const companyData = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Games",
    link: "/game",
  },
  {
    name: "Insights",
    link: "/insights",
  },
  {
    name: "Dashboard",
    link: "/dashboard",
  },
  {
    name: "Rules",
    link: "/rules",
  },
];
const helpData = [
  {
    name: "Safer Gambling",
    link: "safergambling",
  },
  {
    name: "Contact Us",
    link: "#",
  },
  {
    name: "Terms & Conditions",
    link: "/termsandconditions",
  },
  {
    name: "Privacy Policy",
    link: "/privacypolicy",
  },
];
const gamblingIcon = [
  {
    key: 0,
    icon: Gambling1,
    link: "https://www.gamcare.org.uk/get-support/talk-to-us-now/#:~:text=Call%20us%20free%20on%200808%208020%20133",
  },
  {
    key: 1,
    icon: Gambling2,
    link: "https://www.gamblingcommission.gov.uk/public-and-players/safer-gambling",
  },
  {
    key: 2,
    icon: Gambling3,
    link: "https://ibas-uk.com/",
  },
  {
    key: 3,
    icon: Gambling4,
    link: "https://www.begambleaware.org/",
  },
  {
    key: 4,
    icon: Gambling5,
    link: "https://www.gamstop.co.uk",
  },
];
const saferGamblingNavigation = () => {
  setNavItem(8);
};
const Footer = ({ backgroundImageUrl }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const closeModal = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <ContactUsModal visible={isModalVisible} closeModal={closeModal} />
      <footer
        className={`footer ${backgroundImageUrl == "" && "footer-background"}`}
      >
        <div className="d-flex width-100">
          <div className="footer-logo footer-custom-logo">
            <img
              src={SiteLogo}
              alt="Champions Choice Logo"
              className=""
            />
          </div>
        
        </div>
       

        <div className="footer-second font-cairo-normal">
          <div>
            Underage gambling is a criminal offence. Under 21s are strictly
            prohibited to play on Champion’s Choice.{" "}
            <Link to="/termsandconditions" className="footer-terms-link">
              Terms &amp; conditions
            </Link>{" "}
            apply.
          </div>
        </div>
        <div className="footer-copyright font-cairo-normal">
          <div className="footer-social-icons">
            <a
              href="https://www.facebook.com/profile.php?id=61561565724993"
              target="_blank"
              rel="noreferrer"
            >
              <div className="footer-social-icons-image">
                <FacebookIcon />
              </div>
            </a>
            <a
              href="https://www.instagram.com/championschoice.app/"
              rel="noreferrer"
              target="_blank"
            >
              <div className="footer-social-icons-image">
                <InstagramIcon />
              </div>
            </a>

          </div>
          <div className="footer-copyright-text text-center font-cairo-normal">
            © 2025, Champion’s Choice Ltd.
            <br /> All Rights Reserved{" "}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
